import { useRef as d, useReducer as p, useEffect as c, useState as f } from "react";
import "./purify.es-C_c8wluz.mjs";
const l = (e) => {
  const r = d({}), t = {
    status: "idle",
    error: null,
    data: []
  }, [u, n] = p((s, i) => {
    switch (i.type) {
      case "FETCHING":
        return { ...t, status: "fetching" };
      case "FETCHED":
        return { ...t, status: "fetched", data: i.payload };
      case "FETCH_ERROR":
        return { ...t, status: "error", error: i.payload };
      default:
        return s;
    }
  }, t);
  return c(() => {
    let s = !1;
    return !e || !e.trim() ? void 0 : ((async () => {
      if (n({ type: "FETCHING" }), r.current[e]) {
        const a = r.current[e];
        n({ type: "FETCHED", payload: a });
      } else
        try {
          const o = await (await fetch(e)).json();
          if (r.current[e] = o, s) return;
          n({ type: "FETCHED", payload: o });
        } catch (a) {
          if (s) return;
          n({ type: "FETCH_ERROR", payload: a.message });
        }
    })(), function() {
      s = !0;
    });
  }, [e]), u;
}, w = () => {
  const [e, r] = f(window.innerWidth < 768);
  return c(() => {
    const t = () => {
      r(window.innerWidth < 768);
    };
    return window.addEventListener("resize", t), () => {
      window.removeEventListener("resize", t);
    };
  }, []), e;
};
export {
  w as a,
  l as u
};
//# sourceMappingURL=hooks-p7CHkpd2.mjs.map
